module.exports = __webpack_public_path__ + "img/lock.4675ce07.svg";